import axios from '../../http'

class XBPoints {
  // xb根据id获取商品详情
  static postXBPointsContentList(currentPage) {
    const url = `/api/xb/person/point/list?currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBPoints;